import React from 'react';
import GaugeChart from 'react-gauge-chart';
import { Row, Column } from 'react-foundation';

const EngagementGauge = (props) => {
	const curTheme = props.curTheme;
	const colors = props.colors;

	const gaugeborders = [0, 20, 40, 70];
	const gaugeLen = gaugeborders[3] - gaugeborders[0];

	return (
		<div className="gauge">
			<div className="gauge-title">Engagement score</div>
			<GaugeChart
				style={{ height: 130 }}
				textColor={
					curTheme.engagement_score <= gaugeborders[1]
						? colors[0]
						: curTheme.engagement_score <= gaugeborders[2]
						? colors[1]
						: colors[2]
				}
				colors={[colors[0], colors[1], colors[2]]}
				arcsLength={[
					(gaugeborders[1] - gaugeborders[0]) / gaugeLen,
					(gaugeborders[2] - gaugeborders[1]) / gaugeLen,
					(gaugeborders[3] - gaugeborders[2]) / gaugeLen,
				]}
				percent={
					(curTheme.engagement_score - gaugeborders[0]) / gaugeLen
				}
				cornerRadius={15}
				arcWidth={0.1}
				arcPadding={0.02}
				fontSize="30"
				needleColor="#cccccc"
				needleBaseColor={
					curTheme.engagement_score <= gaugeborders[1]
						? colors[0]
						: curTheme.engagement_score <= gaugeborders[2]
						? colors[1]
						: colors[2]
				}
				formatTextValue={(value) => curTheme.engagement_score + '%'}
			/>
			<div className="gauge-info-container">
				<Row>
					<Column small={4}>
						<div
							className="gauge-info"
							style={{ color: '#6351FB' }}
						>
							{' '}
							Purple{' '}
						</div>
						<div className="gauge-info">
							{' '}
							{gaugeborders[0] + '-' + gaugeborders[1] + '%'}{' '}
						</div>
					</Column>
					<Column small={4}>
						<div
							className="gauge-info"
							style={{ color: '#FF9A02' }}
						>
							{' '}
							Orange{' '}
						</div>
						<div className="gauge-info">
							{' '}
							{gaugeborders[1] +
								1 +
								'-' +
								gaugeborders[2] +
								'%'}{' '}
						</div>
					</Column>
					<Column small={4}>
						<div
							className="gauge-info"
							style={{ color: '#28AD25' }}
						>
							{' '}
							Green{' '}
						</div>
						<div className="gauge-info">
							{' '}
							{gaugeborders[2] +
								1 +
								'-' +
								gaugeborders[3] +
								' %'}{' '}
						</div>
					</Column>
				</Row>
			</div>
			<div className="gauge-text">
				A score depicting the percentage of people who have engaged with
				this theme in the last 12 months.
			</div>
		</div>
	);
};

export default EngagementGauge;
